import React from 'react';
import Layout from '@/components/Layout';
import { GlassCard } from '@/components/ui/glass-card';
import { Calendar, Clock, MapPin } from 'lucide-react';

export default function EventsPage() {
  const events = [
    { date: 'Mar 15', month: 'March', title: 'Annual Sports Day', time: '9:00 AM', location: 'School Ground', type: 'Sports' },
    { date: 'Mar 20', month: 'March', title: 'Parent-Teacher Meeting', time: '10:00 AM', location: 'School Auditorium', type: 'Academic' },
    { date: 'Mar 25', month: 'March', title: 'Science Exhibition', time: '11:00 AM', location: 'Science Lab', type: 'Cultural' },
    { date: 'Apr 5', month: 'April', title: 'Annual Function', time: '5:00 PM', location: 'School Auditorium', type: 'Cultural' }
  ];

  const holidays = [
    { date: 'Mar 8', occasion: 'Holi' },
    { date: 'Apr 14', occasion: 'Ambedkar Jayanti' },
    { date: 'Apr 21', occasion: 'Eid-ul-Fitr' }
  ];

  return (
    <Layout>
      <section className="py-20 bg-gradient-to-r from-blue-900 to-blue-950 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-7xl font-bold mb-6">Events & Calendar</h1>
          <p className="text-xl text-blue-100">Stay informed about upcoming events and holidays</p>
        </div>
      </section>
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2">
              <h2 className="text-3xl font-bold text-blue-900 mb-6">Upcoming Events</h2>
              <div className="space-y-6">
                {events.map((event, i) => (
                  <GlassCard key={i}>
                    <div className="flex items-start space-x-4">
                      <div className="bg-blue-900 text-white rounded-xl p-4 text-center min-w-[80px]">
                        <p className="text-3xl font-bold">{event.date.split(' ')[1]}</p>
                        <p className="text-xs uppercase">{event.month}</p>
                      </div>
                      <div className="flex-1">
                        <span className={`inline-block px-3 py-1 text-xs font-semibold rounded-full mb-2 ${
                          event.type === 'Sports' ? 'bg-green-100 text-green-700' :
                          event.type === 'Academic' ? 'bg-blue-100 text-blue-700' :
                          'bg-purple-100 text-purple-700'
                        }`}>
                          {event.type}
                        </span>
                        <h3 className="text-xl font-bold text-blue-900 mb-2">{event.title}</h3>
                        <div className="flex flex-wrap gap-4 text-sm text-slate-600">
                          <div className="flex items-center">
                            <Clock className="w-4 h-4 mr-2" />
                            {event.time}
                          </div>
                          <div className="flex items-center">
                            <MapPin className="w-4 h-4 mr-2" />
                            {event.location}
                          </div>
                        </div>
                      </div>
                    </div>
                  </GlassCard>
                ))}
              </div>
            </div>
            <div>
              <h2 className="text-3xl font-bold text-blue-900 mb-6">School Holidays</h2>
              <GlassCard className="bg-gradient-to-br from-amber-50 to-orange-50">
                <div className="space-y-4">
                  {holidays.map((holiday, i) => (
                    <div key={i} className="flex items-center justify-between py-3 border-b border-amber-200 last:border-0">
                      <div className="flex items-center space-x-3">
                        <Calendar className="w-5 h-5 text-amber-600" />
                        <span className="font-semibold text-blue-900">{holiday.occasion}</span>
                      </div>
                      <span className="text-sm text-slate-600">{holiday.date}</span>
                    </div>
                  ))}
                </div>
              </GlassCard>
              <div className="mt-6 p-6 bg-blue-900 text-white rounded-2xl">
                <h3 className="text-xl font-bold mb-2">School Timings</h3>
                <div className="space-y-2 text-blue-100">
                  <p><strong>School:</strong> 8:00 AM - 1:00 PM</p>
                  <p><strong>Office:</strong> 8:00 AM - 3:00 PM</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
